import { FormattedMessage } from 'react-intl'

import Layout, { LayoutContent, LayoutHeader } from '~/App/components/Layout'

const NotFoundPage = () => {
  return (
    <Layout>
      <LayoutHeader>
        <h1 className="text-xl font-medium">
          <FormattedMessage id="notfound.title" defaultMessage="Not Found" />
        </h1>
      </LayoutHeader>
      <LayoutContent className="flex items-center justify-center text-center">
        <p className="text-lg">
          <FormattedMessage id="notfound.description" />
        </p>
      </LayoutContent>
    </Layout>
  )
}

export default NotFoundPage
